/**
 * Arabic locale strings. RTL — see RTL_LOCALES in ../index.ts.
 */
import type { LocaleStrings } from "./en";

export const ar: LocaleStrings = {
  home: {
    tagline: "حياة هادئة، سحر جنوبي وأسلوب بوهيمي — أزياء مختارة للأرواح الحرّة.",
    footerTagline: "حياة هادئة، سحر جنوبي وأسلوب بوهيمي. أزياء مختارة للأرواح الحرّة.",
  },
  promoTicker: {
    closeLabel: "إغلاق العروض",
    messages: [
      "✨ شحن مجاني للطلبات من 150$ فأكثر ✨",
      "🌿 تصاميم بوهيمية جديدة يوميًا — تسوّقي الأحدث",
      "💛 انضمي إلى عائلة البوهو — وصول مبكر إلى الإصدارات الجديدة",
      "🌹 أزياء بوهيمية مختارة — بلوزات وفساتين ومجوهرات والمزيد",
    ],
  },
  shopByCollection: {
    heading: "تسوّقي حسب المجموعة",
    tagline: "ست جماليات بوهيمية مختارة — اعثري على ما يعبّر عنكِ.",
  },
  categoryCard: {
    shopNow: "تسوّقي الآن",
    productOne: "منتج",
    productOther: "منتجات",
  },
  shopByCategory: {
    heading: "تسوّقي حسب الفئة",
    tagline: "اعثري على إطلالتك البوهيمية المثالية",
    shopNow: "تسوّقي الآن",
    loading: "جاري التحميل…",
    stylesSuffix: "تصميم",
    plusSizeSuffix: "تصميم بمقاسات كبيرة",
    tiles: {
      tops: "بلوزات",
      bottoms: "بناطيل",
      goddess: "Goddess",
      dresses: "فساتين",
      footwear: "أحذية",
      jewelry: "مجوهرات",
      "lifestyle-decor": "نمط حياة وديكور",
    },
  },
  megaMenu: {
    trigger: "المجموعات",
    ariaLabel: "قائمة المجموعات",
    viewAll: "عرض الكل →",
    viewAllCollections: "عرض جميع المجموعات",
    apparelHeading: "ملابس",
    plusLabel: "مقاسات كبيرة",
    taxonomy: {
      apparel: "ملابس",
      goddess: "Goddess",
      lifestyle: "نمط حياة",
      sandals: "صنادل",
      boots: "أحذية برقبة",
      heels: "كعب عالي",
      jewelry: "مجوهرات",
      accessories: "إكسسوارات",
      bags: "حقائب",
      dresses: "فساتين",
      "one-pieces": "قطعة واحدة",
      loungewear: "ملابس استرخاء",
      footwear: "أحذية",
      "lifestyle-decor": "نمط حياة وديكور",
      tops: "بلوزات",
      bottoms: "بناطيل",
      "outfit-sets": "أطقم",
      necklaces: "قلائد",
      earrings: "أقراط",
      bracelets: "أساور",
      rings: "خواتم",
      "bag-charms": "تعليقات حقائب",
      belts: "أحزمة",
      hats: "قبعات",
      "hair-accessories": "إكسسوارات شعر",
      sunglasses: "نظارات شمسية",
      "crossbody-bags": "حقائب كروس",
      handbags: "حقائب يد",
      "shoulder-bags": "حقائب كتف",
      "tote-bags": "حقائب توت",
      "weekender-bags": "حقائب عطلة نهاية الأسبوع",
      "maxi-dresses": "فساتين ماكسي",
      "midi-dresses": "فساتين ميدي",
      "mini-dresses": "فساتين قصيرة",
      jumpsuits: "جمب سوت",
      overalls: "أفرولات",
      rompers: "رومبر",
      "lounge-set": "طقم استرخاء",
      pajamas: "بيجامات",
      "pajamas-set": "طقم بيجاما",
      "hot-chocolate-design": "Hot Chocolate Design",
      "colorstep-fashion": "Colorstep Fashion co.Ltd",
      "area-rugs": "سجاد",
      "accent-furniture": "أثاث مميز",
      "bedding-sets": "أطقم مفارش",
      "table-decor": "ديكور الطاولة",
      "wall-mirrors": "مرايا حائط",
      "throw-blankets": "بطانيات",
      "wall-hangings": "معلقات حائط",
    },
  },
  bohoCollections: {
    "boho-western": {
      title: "بوهو: ويسترن",
      tagline: "شراشيب، جلد الشامواه وروح الفيروز",
      metaDescription:
        "شراشيب وجلد الشامواه والفيروز وروح البراري — أسلوب بوهيمي بلمسة ويسترن.",
    },
    "boho-cottagecore": {
      title: "بوهو: كوتيدج كور",
      tagline: "زهور، تطريز مفرغ ورومانسية ريفية",
      metaDescription:
        "زهور وتطريز مفرغ ورومانسية ريفية — قطع بوهيمية بطابع كوتيدج كور.",
    },
    "boho-coastal": {
      title: "بوهو: ساحلي",
      tagline: "قفاطين، رافيا وهدوء الشاطئ",
      metaDescription:
        "قفاطين ورافيا وأصداف وأجواء منتجعات — أسلوب بوهيمي ساحلي.",
    },
    "boho-festival": {
      title: "بوهو: مهرجانات",
      tagline: "ترتر، لمعان وشراشيب لافتة",
      metaDescription:
        "ترتر ولمعان معدني وشراشيب جريئة — بوهو جاهز للمهرجانات.",
    },
    "boho-earthy": {
      title: "بوهو: ترابي",
      tagline: "تيراكوتا، طين وقوامات حرفية خام",
      metaDescription:
        "تيراكوتا وطين وقوامات حرفية خام — بوهو ترابي وراسخ.",
    },
    "boho-modern": {
      title: "بوهو: عصري",
      tagline: "بساطة مدروسة وفخامة هادئة",
      metaDescription:
        "بساطة، تنسيق محكم وأحادية اللون — بوهو فخم وهادئ.",
    },
  },
};
